"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const react_1 = __importStar(require("react"));
const MemberSongwriterHomeToggle_1 = __importDefault(require("@Components/Navigations/NavBar/MemberSongwriterHomeToggle"));
const MemberSongwriterHandler_1 = __importDefault(require("@Components/Navigations/MemberSongwriterHandler"));
const mobx_react_1 = require("mobx-react");
const MemberSongwriterSwitcher = () => {
    const { uiStore, userStore, popupStore, rightsholderSearchStore, songwriterSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const rightsHoldersData = rightsholderSearchStore.rightsholders;
    const songwriterData = songwriterSearchStore.songwriters;
    (0, react_1.useEffect)(() => () => closeTray(), []);
    const onClick = () => {
        const state = !popupStore.rightsholderTrayState;
        popupStore.setRightsholderTrayState(state);
    };
    const closeTray = () => {
        popupStore.setRightsholderTrayState(false);
    };
    if ((!(rightsHoldersData === null || rightsHoldersData === void 0 ? void 0 : rightsHoldersData.content.length) && !(songwriterData === null || songwriterData === void 0 ? void 0 : songwriterData.content.length)) || userStore.isInternal) {
        return null;
    }
    const hasBoth = !!(rightsHoldersData === null || rightsHoldersData === void 0 ? void 0 : rightsHoldersData.totalElements) && !!(songwriterData === null || songwriterData === void 0 ? void 0 : songwriterData.totalElements);
    const count = uiStore.homePageState === 'member' ? rightsHoldersData === null || rightsHoldersData === void 0 ? void 0 : rightsHoldersData.totalElements : songwriterData === null || songwriterData === void 0 ? void 0 : songwriterData.totalElements;
    const link = uiStore.homePageState === 'member'
        ? navigation_1.default.rightholder.summary(rightsHoldersData.content[0].ipId)
        : navigation_1.default.songwriter.catalog.root(songwriterData.content[0].id);
    return hasBoth ? (react_1.default.createElement(MemberSongwriterHomeToggle_1.default, null,
        react_1.default.createElement(MemberSongwriterHandler_1.default, { count: count, type: uiStore.homePageState, onClick: () => { } }))) : (react_1.default.createElement(MemberSongwriterHandler_1.default, { count: count, type: uiStore.homePageState, firstNavLink: link, onClick: onClick }));
};
exports.default = (0, mobx_react_1.observer)(MemberSongwriterSwitcher);
